export default __webpack_public_path__ + "static/media/error.e1de20dc.svg";